import React, { Component } from 'react'
// import arrowtr from './../../../../include/images/arrow-tr.svg'
import edit from './../../../../include/images/outline/edit.svg'
import crossIcon from '../../../../include/images/cross.svg'
import locationIcon from '../../../../include/images/location-icon.svg'
import PatientPdf from '../../../../include/images/Patientbrochure_YesMindy.pdf'
import _ from 'lodash'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import moment from 'moment'

class ExistingAppointment extends Component {

  formatAMPM(date) {
    var hours = new moment(date, 'HH').utc().hour() // date.getHours();
    var minutes = new moment(date, 'mm').utc().minutes() //date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  render() {
    const clinic = this.props?.clinic ? this.props?.clinic : false
    const doctor =
      this.props.getDoctor.doctors.data[this.props.doctorProfile];

    const clinicType = this.props.appointment?.clinic_type;
    const clinicDetail =
      clinicType === 1
        ? doctor?.clinic_details
        : clinicType === 2
        ? doctor?.clinic_details_2 
        : null;

    const addressText = clinicDetail
      ? `${clinicDetail.address || ""}, ${clinicDetail.city || ""}, ${clinicDetail.state || ""}`
      : "Address not available";

    return (
      <>
   <ReactTooltip className='testPurple' id='orderReview-tooltip'/>
      <div className='side-pannel-box zindex'>
        <div className='tab-sidebar-top d-flex align-items-center'>
          <div className="d-flex justify-content-between">
            <div className='icon-text2'>
              <h6>You Already Have A Scheduled Clinic Appointment.</h6>
            </div>
            <div className='pannel-top2 ml-5'>
              <a
                href='#!'
                className='close'
                onClick={e => this.props.removeBodyClass(e)}>
                <img src={crossIcon} alt='' />
              </a>
            </div>
          </div>
        </div>
        <div className='pannel-tab-box'>
          <div className='card-box'>
            <div className='cb-upper d-flex flex-wrap align-items-start'>
              <div className='cb-upper-content d-flex flex-wrap'>
                <div className='cb-img-box'>
                  <a
                    href={'/dr/' + this.props.doctorProfile.user_name}
                    target='_blank'>
                    <img
                      src={
                        this.props.doctorProfile !== '' &&
                        process.env.REACT_APP_S3URL +
                          this.props.getDoctor.doctors.data[
                            this.props.doctorProfile
                          ].image_url
                      }
                      alt=''
                    />
                  </a>
                </div>
                <div class='cb-text-box'>
                  <div class='doc-intro-desc  font-montserrat'>
                    <h5>
                      {' '}
                      <a
                        href={'/dr/' + this.props.doctorProfile.user_name}
                        target='_blank'>
                        {this.props.doctorProfile !== '' &&
                          this.props.getDoctor.doctors.data[
                            this.props.doctorProfile
                          ].name}
                      </a>
                    </h5>
                    <h6>
                      {this.props.getDoctor.doctors.data[
                        this.props.doctorProfile
                      ].graduation &&
                        this.props.getDoctor.doctors.data[
                          this.props.doctorProfile
                        ].graduation.education}

                      {this.props.getDoctor.doctors.data[
                        this.props.doctorProfile
                      ].post_graduation &&
                        ', ' +
                          this.props.getDoctor.doctors.data[
                            this.props.doctorProfile
                          ].post_graduation.education}

                      {this.props.getDoctor.doctors.data[
                        this.props.doctorProfile
                      ].super_speciality &&
                        ', ' +
                          this.props.getDoctor.doctors.data[
                            this.props.doctorProfile
                          ].super_speciality.education}
                    </h6>

                    <h6>
                      {' '}
                      {
                        this.props.getDoctor.doctors.data[
                          this.props.doctorProfile
                        ].field_type.name
                      }
                    </h6>
                    {this.props.getDoctor.doctors.data[this.props.doctorProfile]
                      .certification && (
                      <h6>
                        {' '}
                        {this.props.getDoctor.doctors.data[
                          this.props.doctorProfile
                        ].certification.length > 0 &&
                          this.props.getDoctor.doctors.data[
                            this.props.doctorProfile
                          ].certification[0].title +
                            '(' +
                            this.props.getDoctor.doctors.data[
                              this.props.doctorProfile
                            ].certification[0].place +
                            ')'}
                      </h6>
                    )}

                    <h6>
                      {' '}
                      {
                        this.props.getDoctor.doctors.data[
                          this.props.doctorProfile
                        ].total_experience
                      }{' '}
                      Years Experience
                    </h6>
                    {this.props.getDoctor.doctors.data[this.props.doctorProfile]
                      .practice_preferences.language.length > 0 && (
                      <h6>
                        Speaks:{' '}
                        {this.props.getDoctor.doctors.data[
                          this.props.doctorProfile
                        ].practice_preferences.language.map((e, i) => (
                          <>
                            <span>{e}</span>
                            {this.props.getDoctor.doctors.data[
                              this.props.doctorProfile
                            ].practice_preferences.language.length -
                              1 !==
                              i && ', '}
                          </>
                        ))}
                      </h6>
                    )}
                    <div class='doc-loc-name d-flex align-items-center'>
                      <div class='location-pin-icon'>
                        <img src={locationIcon} alt='' />
                      </div>{' '}
                      <span>
                        {this.props.getDoctor.doctors.data[
                          this.props.doctorProfile
                        ].clinic_details &&
                          this.props.getDoctor.doctors.data[
                            this.props.doctorProfile
                          ].clinic_details.city}
                        ,{' '}
                        {this.props.getDoctor.doctors.data[
                          this.props.doctorProfile
                        ].clinic_details &&
                          this.props.getDoctor.doctors.data[
                            this.props.doctorProfile
                          ].clinic_details.state}
                      </span>
                    </div>
                    <div class='doc-fee-desc'>
                      {this.props.getDoctor.doctors.data[
                        this.props.doctorProfile
                      ].schedules.clinicFee &&
                      this.props.getDoctor.doctors.data[
                        this.props.doctorProfile
                      ].schedules.clinicFee > 0 ? (
                        <div class='d-flex align-items-center'>
                          {' '}
                          <strong>Physical Fee: </strong>
                          <ul class='fee-list d-flex align-items-center'>
                            <li>
                              ₹{' '}
                              {
                                this.props.getDoctor.doctors.data[
                                  this.props.doctorProfile
                                ].schedules.clinicFee
                              }
                            </li>
                            <li>
                              {
                                this.props.getDoctor.doctors.data[
                                  this.props.doctorProfile
                                ].schedules.time
                              }
                              mins
                            </li>
                          </ul>
                        </div>
                      ) : (
                        ''
                      )}

                      {this.props.getDoctor.doctors.data[
                        this.props.doctorProfile
                      ].schedules.onlineFee &&
                      this.props.getDoctor.doctors.data[
                        this.props.doctorProfile
                      ].schedules.onlineFee > 0 ? (
                        <div class='d-flex align-items-center'>
                          {' '}
                          <strong>Online Fee: </strong>
                          <ul class='fee-list d-flex align-items-center'>
                            <li>
                              ₹{' '}
                              {
                                this.props.getDoctor.doctors.data[
                                  this.props.doctorProfile
                                ].schedules.onlineFee
                              }
                            </li>
                            <li>
                              {
                                this.props.getDoctor.doctors.data[
                                  this.props.doctorProfile
                                ].schedules.time
                              }
                              mins
                            </li>
                          </ul>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='pannel-intro-box'>
            <div className='separator'></div>
            <div className='pi-body d-flex flex-wrap'>
              <div className='pi-left'>
                <h3>Date &amp; Timing</h3>
                <p>
                  {new moment(this.props.appointment?.appointment_time)
                    .utc()
                    .date()}{' '}
                  {
                    this.props.months[
                      new moment(this.props.appointment?.appointment_time)
                        .utc()
                        .month()
                    ]
                  }{' '}
                  |{' '}
                  {this.formatAMPM(
                    new Date(this.props.appointment?.appointment_time)
                  )}
                </p>
              </div>

              <div className='pi-right'>
                <h3>Type of visit</h3>
                <p>
                  {_.capitalize(this.props.appointment?.appointment_type)}
                  {(clinicType != 0) && (
                    <i
                      data-tooltip-id='orderReview-tooltip'
                      data-tooltip-content={addressText}
                      className={`fa-duotone fa-circle-${clinicType} fa-lg ml-1`}
                      aria-hidden='true'
                      style={{
                        "--fa-primary-color": "rgb(98, 27, 192)",
                        "--fa-secondary-color": "rgb(98, 27, 192)"
                      }}
                    ></i>
                  )}
                </p>
              </div>
            </div>
            <div className='pi-body d-flex flex-wrap'>
              <div className='pi-left'>
                <ul>
                  <li>
                    <p>
                      Consultation Charges
                      {this.props.appointment?.duration &&
                        ` (${this.props.appointment.duration}mins)`
                      }
                    </p>
                  </li>
                </ul>
              </div>
              <div className='pi-right'>
                <ul>
                  <li>
                    <p>
                      ₹{' '}
                      {this.props.appointment?.consultation_charges.toFixed(
                        2
                      )}
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className='separatorNew'></div>
            <div className='pi-body d-flex flex-wrap'>
              <p style={{ fontSize: '11px', marginBottom: 0 }}>
                * To cancel the appointment please contact the counselling team.
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
            <button
                className="btn btn-primary"
                onClick={this.props.onReschedule}
            >
                Reschedule Appointment
            </button>
            </div> 
          </div>
        </div>
      </div>
   </> )
  }
}

export default ExistingAppointment
